import React, {PropsWithChildren} from 'react';
import {ListItem, Typography} from '@genestack/ui';
import styles from './metadata.module.css';

interface Props {
    label: string;
}

export const MetadataEntry = ({label, children}: PropsWithChildren<Props>) => (
    <ListItem>
        <Typography box="inline">{label}</Typography>

        <Typography box="inline" intent="quiet" className={styles.metadataEntry}>
            {children}
        </Typography>
    </ListItem>
);
